"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";

import { isSensitivePaymentPath } from "@/lib/sensitive-route-policy";

// Routes that render as bare, single-decision surfaces — the full site nav +
// footer are an attention leak on a checkout (rule 39). /cart gets only a
// minimal "Secure checkout" header (see app/cart/layout.tsx). Every other route
// renders chrome exactly as before.
const BARE_CHROME_PREFIXES = ["/cart"];

function isBareChrome(pathname: string | null): boolean {
  if (!pathname) return false;
  if (isSensitivePaymentPath(pathname)) return true;
  return BARE_CHROME_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export function ChromeGate({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (isBareChrome(pathname)) return null;
  return <>{children}</>;
}
